/**
 * Empty-state buttons inside the per-view-type renderers (calendar / chart /
 * transpose) want to open the same settings menu the toolbar opens.
 *
 * On wide screens the toolbar button is in the DOM, so we just dispatch a
 * click on it — the menu pops up exactly where the toolbar button is.
 *
 * On narrow screens the toolbar collapses the per-view button into the
 * "view config" dropdown (so the button is no longer in the DOM). We fall
 * back to a tiny pub/sub the toolbar subscribes to: it opens the menu in
 * the top-right of the viewport, visually consistent with where the
 * dropdown would have anchored it anyway.
 */
export type ToolbarSettingsButtonId = 'table-chart-button' | 'table-pivot-button' | 'table-matrix-button'

type FallbackListener = (button: ToolbarSettingsButtonId) => void

const fallbackListeners: Set<FallbackListener> = new Set()

export function subscribeOpenViewSettingsMenu(listener: FallbackListener): () => void {
  fallbackListeners.add(listener)
  return () => {
    fallbackListeners.delete(listener)
  }
}

export function openViewSettings(button: ToolbarSettingsButtonId): void {
  const toolbarButton = document.querySelector<HTMLElement>(`[data-testid="${button}"]`)
  if (toolbarButton) {
    toolbarButton.click()
    return
  }
  for (const listener of fallbackListeners) listener(button)
}
